/** Guest name of a reservation the new-reservation form created but has not finished. */
export const PLACEHOLDER_GUEST_NAME = 'Wird gerade erstellt';

// Holds the backend owns: ticket, minimum-consumption and payment flows clear
// their own validTill, so the dashboard must never release them, not even once
// expired. Mirrors the skip condition of the day-view cleanup.
export const hasBackendOwnedHold = (reservation: {
  ticketId?: string | null;
  minimumConsumption?: any;
  payment?: any;
  exclusiveOfferId?: string | null;
}) =>
  !!reservation.ticketId ||
  !!reservation.minimumConsumption ||
  !!reservation.payment ||
  // A table held for an exclusive offer: the API ends it.
  !!reservation.exclusiveOfferId;

/**
 * An unfinished form placeholder the dashboard may remove; never a hold
 * another flow took over, nor one the API marked as its own hold.
 */
export const isRemovablePlaceholder = (
  reservation:
    | ({ guest?: { name?: string }; provisionalHold?: boolean } & Parameters<typeof hasBackendOwnedHold>[0])
    | undefined
) =>
  !!reservation &&
  reservation.guest?.name === PLACEHOLDER_GUEST_NAME &&
  !reservation.provisionalHold &&
  !hasBackendOwnedHold(reservation);
